__turbopack_context__.v({
  "large": "paragraph-module-scss-module__Vu7-0a__large",
  "paragraph": "paragraph-module-scss-module__Vu7-0a__paragraph",
  "regular": "paragraph-module-scss-module__Vu7-0a__regular",
  "rideTillYouDie": "paragraph-module-scss-module__Vu7-0a__rideTillYouDie",
});
